import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { GridSpinnerComponent } from 'src/app/shared/grid-spinner.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { Optional } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import { DialogComponent } from 'src/app/shared/dialog.component';

@Component({
  selector: 'app-expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit {
  @ViewChild(DialogComponent, { static: true }) cwdialog: DialogComponent;

  showPaymentButton = true;
  dialogTitle:string;

  @Input()
  dialogMessage:string;

  @Input()
  dialogReason:string;

  paymentButtonText = 'Buy Now';

  constructor(private _logger: LoggerService, public _sessionService: SessionService, public themeManager: ThemeManagerService, private _platformApi: PlatformApiService, @Optional() public selfDialog: MatDialogRef<ExpiredComponent>, private dialog: MatDialog) { }

  ngOnInit() {
    let newDialogMessage;
    if (this._sessionService.isSubAccount()) {
      this.dialogTitle = 'Unavailable';
      newDialogMessage = 'This account is not currently available. Please contact your administrator to restore access.'
      this.showPaymentButton = false;
    } else {
      if (this._sessionService.getInstanceStatus() == 'active' && this._sessionService.getPaymentStatus() != 'cancelled') {
        if (this._sessionService.isExpiredTrial()) {
          this.dialogTitle = 'Expired';
          newDialogMessage = 'Your trial period has reached the end. Don’t worry! You can continue to assess risk for all of your customers by upgrading to a paid subscription.'
        } else if (this._sessionService.getCurrentAccount().planSubscription.paymentStatus == 'missing') {
          this.dialogTitle = 'Update Payment Information';
          newDialogMessage = 'We were unable to process your current method of payment.  Please review and update the billing information or recurrence on your account to continue providing risk assessments to all of your customers.';
          this.paymentButtonText = 'Update Account';
        } else if (this.dialogReason == 'FEATUREUNAVAILABLE') {
          this.dialogTitle = 'Upgrade Account';
          newDialogMessage = 'Your current subscription does not support that feature. Please upgrade your account.';
          this.paymentButtonText = 'Upgrade Account';
        }
      } else {
        if (this._sessionService.getInstanceStatus() == 'stopped' && this._sessionService.getPaymentStatus() == 'missing') {
          this.dialogTitle = 'Update Payment Information';
          newDialogMessage = 'We were unable to process your current method of payment.  Please review and update the billing information or recurrence on your account to continue providing risk assessments to all of your customers.';
          this.paymentButtonText = 'Update Account';
        } else {
          this.dialogTitle = 'Unavailable';
          newDialogMessage = 'Your account is currently unavailable. Please contact support.';
          this.showPaymentButton = false;
        }
      }
    }

    if (this.dialogMessage == undefined) {
      this.dialogMessage = newDialogMessage;
    }
  }

  buyNow() {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: ['You are being redirected to our new ConnectWise payment system.',
                        'You will need to register for an account and confirm your registration before you complete your Identify purchase. Please be sure that you create this account with the same email address that you use to log into Identify.',
                        'For more detailed instructions, please refer to <a href="https://docs.connectwise.com/ConnectWise_Identify/006/ConnectWise_Identify_Purchase_Process" target="_blank">this University guide</a>.',
                        'Please note that after purchasing you will need to log out and log back in to Identify.'],
        promptTitle: 'Partner Portal Redirect'
      }
    });
    dialogRef.afterClosed().subscribe(resp => {
      if (resp == true) {
        this._logger.log('Expired user account selected Buy Now');
        if (this.cwdialog != undefined) {
          this.cwdialog.spinner.showSpinner('Redirecting to Partner Portal');
        }
        this._platformApi.getReferralUrl(this._sessionService.getCurrentAccount().id).subscribe(rp => {
          window.open(rp, '_blank');
          if (this.cwdialog != undefined) {
            this.cwdialog.spinner.hideSpinner();
          }
          if (this.selfDialog) {
            this.selfDialog.close();
          }
        }, err => {
          if (this.cwdialog != undefined) {
            this.cwdialog.spinner.showMessage('An error occurred. Please contact an administrator.', 5000);
          }
        })
      }
    });
  }

}
